package com.xtream.composeapp.presentation.ui.navigation

import androidx.compose.runtime.mutableStateListOf
import androidx.lifecycle.ViewModel
import com.xtream.composeapp.data.Screen
import kotlinx.coroutines.ExperimentalCoroutinesApi

class RootNavViewModel (initialRoute: Screen = Screen.Loading()) : ViewModel() {
     val backStack = mutableStateListOf<Screen>( initialRoute)//Screen.LiveTvGrid(AllConst.FAV_CATEGORIES_ID.toInt(),"FAV") )

    @OptIn(ExperimentalCoroutinesApi::class)
    fun  navigate(route: Screen) {
         if (!backStack.contains(route))
          backStack.add(route)
        /* viewModelScope.launch {
             _route.emit(route)
             Log.d( "HomeScreen", "Screen_: ${_route.value}")

         }*/
    }

    fun  pop(route: Screen): Boolean {
            return backStack.remove(route)
    }

    fun  pop( ): Screen? {
        return backStack.removeLastOrNull()
    }

    }